var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 2.84375L3.35156 10.9688C3.37568 11.4382 3.71719 11.7812 4.16406 11.7812H8.83594C9.28459 11.7812 9.61975 11.4382 9.64844 10.9688L10.1562 2.84375",
    stroke: "#707070",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 2.84375H10.9688H2.03125Z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 2.84375H10.9688",
    stroke: "#707070",
    strokeWidth: 0.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 2.84375V1.82813C4.87477 1.74804 4.89037 1.66869 4.92091 1.59465C4.95145 1.52061 4.99633 1.45334 5.05296 1.39671C5.10959 1.34008 5.17686 1.2952 5.2509 1.26466C5.32494 1.23412 5.40428 1.21852 5.48438 1.21875H7.51562C7.59572 1.21852 7.67506 1.23412 7.7491 1.26466C7.82314 1.2952 7.89041 1.34008 7.94704 1.39671C8.00367 1.45334 8.04855 1.52061 8.07909 1.59465C8.10963 1.66869 8.12523 1.74804 8.125 1.82813V2.84375M6.5 4.46875V10.1563M4.67188 4.46875L4.875 10.1563M8.32812 4.46875L8.125 10.1563",
    stroke: "#707070",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.2944ce3659158c3664050cb3cf5ba5d7.svg";
export { ForwardRef as ReactComponent };